// True when the viewer has asked the OS to minimise animation. Used to skip
// the countdown, count-ups, confetti and other flourishes for accessibility.
export function prefersReducedMotion() {
  return typeof window !== 'undefined'
    && typeof window.matchMedia === 'function'
    && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
